import { useTranslation } from 'react-i18next'

import { Box, Stack, Typography } from '@mui/material'

import responsiveHook from '@hooks/useResponsive'

import { TLGTypography } from '@components/TLGTypography'

import {
  containerSx,
  contentSx,
  heroLeftSideContentSx,
  heroOverTitleSx,
  heroSubtitleSx,
  heroTitleSx,
  overlaySx,
} from './styles'

const HeroSection = () => {
  const { t } = useTranslation()
  const { isMobileOrTablet } = responsiveHook.useResponsive()

  return (
    <Box data-testid="tech-vendors-pricing-hero-section" sx={containerSx}>
      {isMobileOrTablet && <Box sx={overlaySx} />}
      <Box sx={contentSx}>
        <Stack sx={heroLeftSideContentSx}>
          <Typography variant="h6" sx={heroOverTitleSx}>
            {t('Pricing')}
          </Typography>
          <TLGTypography
            responsiveVariant={{ xs: 'h5', md: 'h4' }}
            component="h1"
            sx={heroTitleSx}
          >
            {t('Join The Launchpad: Your Gateway to IT Matchmaking!')}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            component="h2"
            sx={heroSubtitleSx}
          >
            {t(
              `Subscribe to The Launchpad today and experience the power of advanced matchmaking tailored specifically for IT professionals like you. Also, it is free for Tech Customers!`
            )}
          </TLGTypography>
        </Stack>
      </Box>
    </Box>
  )
}

export { HeroSection }
